import { isEmpty } from 'lodash/fp';
// @ts-expect-error - Automatic, Please fix when editing this file
import getEligibleRewards from '@ahmdigital/offers/lib/model/offer/get-eligible-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import getUpsellApplicableRewards from '@ahmdigital/offers/lib/model/offer/get-upsell-applicable-rewards';
// @ts-expect-error - Automatic, Please fix when editing this file
import isOfferEligible from '@ahmdigital/offers/lib/model/offer/is-eligible';

import type { Offer } from '../../types';

type FilterOffersInput = {
  filterProductId: string;
  offers: Offer[] | null | undefined;
};

const filterOffers = ({ filterProductId, offers }: FilterOffersInput): Offer[] => {
  const scenarioForRewardEligibility = { productId: filterProductId };
  const offerList: Offer[] = offers ?? [];

  const eligibleOffers = offerList.filter((offer) => isOfferEligible(offer, scenarioForRewardEligibility));

  if (!isEmpty(eligibleOffers)) return eligibleOffers;

  return offerList.filter((offer) => {
    const eligibleRewards = getEligibleRewards(offer, scenarioForRewardEligibility);
    const upsellApplicableRewards = getUpsellApplicableRewards(offer, scenarioForRewardEligibility);
    const rewards = isEmpty(eligibleRewards) ? upsellApplicableRewards : eligibleRewards;

    return !isEmpty(rewards);
  });
};

export default filterOffers;
